var render, staticRenderFns
import script from "./DoubleBar.vue?vue&type=script&lang=js&"
export * from "./DoubleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4711b081')) {
      api.createRecord('4711b081', component.options)
    } else {
      api.reload('4711b081', component.options)
    }
    
  }
}
component.options.__file = "src/components/graph/DoubleBar.vue"
export default component.exports